import { render, staticRenderFns } from "./tags-table.vue?vue&type=template&id=9ced1c14&scoped=true&"
import script from "./tags-table.vue?vue&type=script&lang=js&"
export * from "./tags-table.vue?vue&type=script&lang=js&"
import style0 from "./tags-table.vue?vue&type=style&index=0&id=9ced1c14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ced1c14",
  null
  
)

export default component.exports